import React, { useEffect, useState } from "react";
import Apiservice from "../Apiservice";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Payslip = () => {
    const location = useLocation();
    const staff = location.state?.staff;

    const navigate = useNavigate();

    const [staffName, setStaffName] = useState("");
    const [staffId, setStaffId] = useState("");
    const [account, setAccount] = useState("");
    const [accountShow, setAccountShow] = useState(true);
    const [role, setRole] = useState("");
    const [site, setSite] = useState("");

    const [periodStart, setPeriodStart] = useState("");
    const [periodEnd, setPeriodEnd] = useState("");
    const [dateOfPayment, setDateOfPayment] = useState("");
    const [modeOfPaymentId, setModeOfPaymentId] = useState(0);
    const [modeOfPayment, setModeOfPayment] = useState([
        { "id": 1, "mode": "Bank Transfer" },
        { "id": 2, "mode": "upi" }
    ]);

    // Dynamic Fields
    const [basicPay, setBasicPay] = useState(0);
    const [allowances, setAllowances] = useState([{ name: "", amount: "" }]);
    const [others, setOthers] = useState([{ name: "", amount: "" }]);

    // Overtime
    const [overtimeHours, setOvertimeHours] = useState('');
    const [overtimePay, setOvertimePay] = useState('');
    const [totalOvertimeAmount, setTotalOvertimeAmount] = useState(0);

    // Deductions
    const [employeeCPF, setEmployeeCPF] = useState("");
    const [advancePay, setAdvancePay] = useState("");
    const [loan, setLoan] = useState("");
    const [unpaidLeaveDays, setUnpaidLeaveDays] = useState([]);
    const [unpaidLeaveAmount, setUnpaidLeaveAmount] = useState(0);
    const [totalUnpaidLeaveAmount, setTotalUnpaidLeaveAmount] = useState(0);
    const [deductions, setDeductions] = useState(0);

    // Final
    const [netPay, setNetPay] = useState(0);
    const [employersCPF, setEmployersCPF] = useState(0);

    useEffect(() => {
        if (staff) {
            setStaffName(`${staff.firstName} ${staff.lastName}`);
            setStaffId(staff.employeeId);
            setAccount(staff.accountNo);
            setRole(staff.roleName);
            setSite(staff.siteName);

            // ✅ Sum all overtime hours from attendance
            const totalOvertime = (staff.attendance || []).reduce(
                (sum, a) => sum + Number(a.overtimeHours || 0),
                0
            );
            setOvertimeHours(totalOvertime);

            // ✅ Extract pay details from KET
            let ket = staff.ket?.[0];
            setBasicPay(Number(ket?.basicRateOfPay || 0));
            setOvertimePay(Number(ket?.overtimeRateOfPay || 0));
        }
    }, [staff]);




    // --- Calculations ---
    useEffect(() => {
        setTotalOvertimeAmount(Number(overtimeHours) * Number(overtimePay));
    }, [overtimeHours, overtimePay]);

    useEffect(() => {
        setTotalUnpaidLeaveAmount(unpaidLeaveDays * unpaidLeaveAmount);
    }, [unpaidLeaveDays, unpaidLeaveAmount]);

    useEffect(() => {
        const totalAllowances = allowances.reduce((sum, a) => sum + Number(a.amount || 0), 0);
        const totalOthers = others.reduce((sum, o) => sum + Number(o.amount || 0), 0);
        const totalDeductions = employeeCPF + advancePay + totalUnpaidLeaveAmount;

        setDeductions(totalDeductions);
        setNetPay(basicPay + totalAllowances + totalOthers + totalOvertimeAmount - totalDeductions);
    }, [basicPay, allowances, others, employeeCPF, advancePay, totalUnpaidLeaveAmount, totalOvertimeAmount]);

    // --- Handlers for dynamic fields ---
    const handleAllowanceChange = (index, field, value) => {
        const newAllowances = [...allowances];
        newAllowances[index][field] = value;
        setAllowances(newAllowances);
    };

    const addAllowance = () => setAllowances([...allowances, { name: "", amount: 0 }]);

    const handleOtherChange = (index, field, value) => {
        const newOthers = [...others];
        newOthers[index][field] = value;
        setOthers(newOthers);
    };

    const addOther = () => setOthers([...others, { name: "", amount: 0 }]);

    // --- Submit ---
    const handleSubmit = async () => {
        let data = {
            userId: staff.id,
            periodStart,
            periodEnd,
            dateOfPayment,
            modeOfPaymentId,
            basicPay,
            allowances,
            others,
            overtime: [{ overtimeHours, overtimePay, totalOvertimeAmount }],
            deductions: [{
                employeeCPF,
                advancePay,
                unpaidLeaveDays,
                unpaidLeaveAmount,
                totalUnpaidLeaveAmount,
                totalDeductions: deductions
            }],
            netPay,
            employersCPF,
            totalAmount: basicPay + allowances.reduce((s, a) => s + Number(a.amount || 0), 0) + others.reduce((s, o) => s + Number(o.amount || 0), 0) + totalOvertimeAmount
        };

        let result = await Apiservice.PayslipAdd(data);

        if (result.success === true) {
            Swal.fire({
                title: "Success!",
                text: "Payslip added successfully",
                icon: "success",
                confirmButtonText: "OK",
            });
            navigate('/salariedstaff')
            
        }
        else {
            Swal.fire({
                title: "Error!",
                text: result.message || "Something went wrong",
                icon: "error",
                confirmButtonText: "OK",
            });
        }

    };

    return (
        <div className="container my-2">
            <h3 className="mb-4 text-center">Employee Payslip</h3>

            {/* Employee Info */}
            <div className="card shadow-sm mb-3">
                <div className="card-header fw-bold">Employee Details</div>
                <div className="card-body row">
                    <div className="col-md-3"><strong>Name:</strong> {staffName}</div>
                    <div className="col-md-3"><strong>ID:</strong> {staffId}</div>
                    <div className="col-md-3"><strong>Role:</strong> {role}</div>
                    <div className="col-md-3"><strong>Site:</strong> {site}</div>
                </div>
            </div>

            {/* Payment Info */}
            <div className="card shadow-sm mb-3">
                <div className="card-header fw-bold">Payment Information</div>
                <div className="card-body row g-3">
                    <div className="col-md-2">
                        <label className="form-label">Period Start</label>
                        <input type="date" className="form-control" value={periodStart} onChange={(e) => setPeriodStart(e.target.value)} />
                    </div>
                    <div className="col-md-2">
                        <label className="form-label">Period End</label>
                        <input type="date" className="form-control" value={periodEnd} onChange={(e) => setPeriodEnd(e.target.value)} />
                    </div>
                    <div className="col-md-2">
                        <label className="form-label">Date of Payment</label>
                        <input type="date" className="form-control" value={dateOfPayment} onChange={(e) => setDateOfPayment(e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Mode of Payment</label>
                        <select
                            className="form-select"
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                setModeOfPaymentId(selectedId);

                                const selectedMode = modeOfPayment.find(m => m.id == selectedId);
                                if (selectedMode?.mode === "Bank Transfer") {
                                    setAccountShow(true);
                                } else {
                                    setAccountShow(false);
                                }
                            }}
                        >
                            {modeOfPayment.length > 0 ? (
                                modeOfPayment.map((mode) => (
                                    <option value={mode.id} key={mode.id}>{mode.mode}</option>
                                ))
                            ) : (
                                <option value="">No modes Available</option>
                            )}
                        </select>

                    </div>
                    {
                        accountShow && (
                            <div className="col-md-3">
                                <label className="form-label">Account Details</label>
                                <input type="text" className="form-control" value={account} disabled />
                            </div>
                        )
                    }

                </div>
            </div>

            {/* Salary Info */}
            <div className="card shadow-sm mb-3">
                <div className="card-header fw-bold">Salary Details</div>
                <div className="card-body row g-3">
                    <div className="col-md-2">
                        <label className="form-label">Basic Pay</label>
                        <input type="number" className="form-control" value={basicPay} onChange={(e) => setBasicPay(Number(e.target.value))} />
                    </div>

                    <div className="col-md-5">
                        <label className="form-label">Allowances</label>
                        {allowances.map((a, idx) => (
                            <div key={idx} className="input-group mb-2">
                                <input type="text" className="form-control" placeholder="Name"
                                    value={a.name} onChange={(e) => handleAllowanceChange(idx, "name", e.target.value)} />
                                <input type="number" className="form-control" placeholder="Amount"
                                    value={a.amount} onChange={(e) => handleAllowanceChange(idx, "amount", Number(e.target.value))} />
                            </div>
                        ))}
                        <button className="btn btn-sm btn-outline-primary" onClick={addAllowance}>+ Add Allowance</button>
                    </div>

                    <div className="col-md-5">
                        <label className="form-label">Others</label>
                        {others.map((o, idx) => (
                            <div key={idx} className="input-group mb-2">
                                <input type="text" className="form-control" placeholder="Name"
                                    value={o.name} onChange={(e) => handleOtherChange(idx, "name", e.target.value)} />
                                <input type="number" className="form-control" placeholder="Amount"
                                    value={o.amount} onChange={(e) => handleOtherChange(idx, "amount", Number(e.target.value))} />
                            </div>
                        ))}
                        <button className="btn btn-sm btn-outline-primary" onClick={addOther}>+ Add Other</button>
                    </div>
                </div>
            </div>

            {/* Overtime */}
            <div className="card shadow-sm mb-3">
                <div className="card-header fw-bold">Overtime</div>
                <div className="card-body row g-3">
                    <div className="col-md-4">
                        <label className="form-label">Hours Worked</label>
                        <input type="number" className="form-control" value={overtimeHours} onChange={(e) => setOvertimeHours(Number(e.target.value))} />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Overtime Pay (per hour)</label>
                        <input type="number" className="form-control" value={overtimePay} onChange={(e) => setOvertimePay(Number(e.target.value))} />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">Total Overtime Amount</label>
                        <input type="number" className="form-control" value={totalOvertimeAmount} readOnly />
                    </div>
                </div>
            </div>

            {/* Deductions */}
            <div className="card shadow-sm mb-3">
                <div className="card-header fw-bold">Deductions</div>
                <div className="card-body row g-3">
                    <div className="col-md-3">
                        <label className="form-label">Employee CPF</label>
                        <input
                            type="number"
                            className="form-control"
                            value={employeeCPF}
                            onChange={(e) => setEmployeeCPF(e.target.value)}
                        />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Advance Pay</label>
                        <input type="number" className="form-control" value={advancePay} onChange={(e) => setAdvancePay(e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Loan</label>
                        <input type="number" className="form-control" value={advancePay} onChange={(e) => setAdvancePay(e.target.value)} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Loan Details</label>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Unpaid Leave Days</label>
                    </div>
                    <div className="col-md-3">
                        <label className="form-label">Unpaid Leave Amount</label>
                        <input type="number" className="form-control" value={unpaidLeaveAmount} onChange={(e) => setUnpaidLeaveAmount(Number(e.target.value))} />
                    </div>
                    <div className="col-md-12 mt-2">
                        <label className="form-label">Total Deductions</label>
                        <input type="number" className="form-control" value={deductions} readOnly />
                    </div>
                </div>
            </div>

            {/* Summary */}
            <div className="card shadow-sm mb-3">
                <div className="card-header fw-bold">Summary</div>
                <div className="card-body row">
                    <div className="col-md-4"><strong>Net Pay:</strong> ₹ {netPay}</div>
                    <div className="col-md-4"><strong>Employer CPF:</strong> ₹ {employersCPF}</div>
                    <div className="col-md-4"><strong>Total (Gross Before Deductions):</strong> ₹ {basicPay + allowances.reduce((s, a) => s + Number(a.amount || 0), 0) + others.reduce((s, o) => s + Number(o.amount || 0), 0) + totalOvertimeAmount}</div>
                </div>
            </div>

            {/* Submit */}
            <div className="text-end">
                <button className="btn btn-success btn-lg" onClick={handleSubmit}>💾 Save Payslip</button>
            </div>
        </div >
    );
};

export default Payslip;
